var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initCustomBundle = /* @__PURE__ */ __name(($el, $refs) => {
  const random_id = utils.shortUUID();
  const stepBlocks = document?.querySelectorAll("[data-step");
  const columnElements = [$refs.main_content, $refs.sidebar].filter(Boolean);
  const scroll_column_element = columnElements?.reduce(
    (acc, element) => acc?.scrollHeight > element?.scrollHeight ? acc : element
  );
  scroll_column_element?.classList?.remove("lg:sticky-product-section");
  scroll_column_element?.classList?.add("relative");
  const section_settings = utils.JSONParse(
    $el.getAttribute("data-section-settings")
  );
  const bundle_targets = utils.JSONParse($el.getAttribute("data-bundle-target")) ?? [];
  const initial_bundle_target_id = bundle_targets?.[0]?.id;
  const initial_target = {
    ...bundle_targets?.[0]
  };
  bundle_targets?.sort((a, b) => a.settings?.target - b?.settings?.target);
  const bundle_target_objects = bundle_targets?.reduce((acc, item, i) => {
    acc[item.id] = item.settings;
    return acc;
  }, {});
  const incentive_targets = utils.JSONParse(
    $el.getAttribute("data-incentive-target")
  ) ?? [];
  const bundle_type = section_settings.bundle_target_type;
  const state = window.Alpine.reactive({
    items_added: [],
    item_added_summary: [],
    steps: [],
    modal_step: 1,
    scroll_column_element,
    bundle_target_id: initial_bundle_target_id,
    total_price: 0,
    discounted_price: 0,
    current_wording: "",
    difference_wording: "",
    target_wording: "",
    final_price: 0,
    before_discounts_price: 0,
    target_discount_wording: "",
    active_target_discount_wording: "",
    discount_wording: "",
    active_discount_wording: "",
    item_count: 0,
    target_difference: "",
    bundle_target: initial_target?.settings,
    achieved_bundle_target: null,
    incentive_target: incentive_targets?.[0],
    isAdding: false,
    items_added_to_cart: false,
    addToBundle: /* @__PURE__ */ __name(() => {
    }, "addToBundle"),
    removeFromBundle: /* @__PURE__ */ __name(() => {
    }, "removeFromBundle"),
    removeFromBundleByIndex: /* @__PURE__ */ __name(() => {
    }, "removeFromBundleByIndex"),
    updateStep: /* @__PURE__ */ __name(() => {
    }, "updateStep"),
    setModalStep: /* @__PURE__ */ __name(() => {
    }, "setModalStep")
  });
  window.Alpine.effect(() => {
    stepBlocks?.forEach((step) => {
      const stepIndex = +step?.getAttribute("data-step");
      if (!state?.steps[stepIndex]) {
        state.steps.push({
          skipped: false,
          open: false,
          confirmed: false
        });
      }
    });
    if (state?.steps?.length > 0) {
      window.Alpine.store("bundle", {
        state
      });
      const bundle = window.Alpine.store("bundle");
      window.Alpine.magic("bundle", () => bundle);
      window._stores["bundle"] = bundle;
    }
    state.item_count = state.items_added.reduce(
      (acc, item, index) => state.steps[index]?.confirmed ? acc += item?.quantity : acc,
      0
    );
    state.total_price = state.items_added.reduce(
      (acc, item, index) => state.steps[index]?.confirmed ? acc += item?.price_override ?? item.variant?.price : acc,
      0
    );
    state.achieved_bundle_target = [...bundle_targets].sort((a, b) => b.settings?.target - a?.settings?.target)?.find((bundle) => bundle.settings.target <= state?.[bundle_type])?.settings;
    state.discounted_price = state.total_price - (state.achieved_bundle_target?.discount_amount ?? 0) - state.total_price * ((state?.achieved_bundle_target?.discount_percentage ?? 0) / 100);
    state.before_discounts_price = state.total_price;
    state.final_price = state.discounted_price;
    state.target_difference = bundle_type === "item_count" ? state.bundle_target?.target - state.item_count > 0 ? `${state.bundle_target?.target - state.item_count}` : "" : state.bundle_target?.target - state.total_price ? `${utils.formatMoney(state.bundle_target?.target - state.item_count)}` : "";
    state.target_wording = bundle_type === "item_count" ? `${state.bundle_target?.target}` : utils.formatMoney(state.bundle_target?.target);
    state.current_wording = bundle_type === "item_count" ? `${state.item_count}` : utils.formatMoney(state.total_price);
    state.difference_wording = bundle_type === "item_count" ? `${state.bundle_target?.target - state.item_count}` : utils.formatMoney(state.bundle_target?.target - state.total_price);
    state.target_discount_wording = state.bundle_target?.discount_amount ? `Save ${utils.formatMoney(state.bundle_target?.discount_amount)}` : state?.bundle_target?.discount_percentage ? `${state?.bundle_target?.discount_percentage}% off` : "";
    state.discount_wording = `${utils.roundToIndex(
      (1 - state.final_price / state.total_price) * 100,
      0
    )}% off`;
    state.active_target_discount_wording = state.total_price > state.final_price ? state.target_discount_wording : "";
    state.active_discount_wording = state.total_price > state.final_price ? state.discount_wording : "";
    state.item_added_summary = state?.items_added?.reduce((acc, item, index) => {
      if (state.steps[index]?.confirmed) {
        const addedIndex = acc.findIndex((item2) => item?.variant?.id === item2?.variant?.id);
        if (addedIndex !== -1 && item.price_override === acc[addedIndex]["price_override"]) {
          acc[addedIndex]["quantity"] += 1;
        } else {
          acc.push({
            quantity: 1,
            price: item.variant?.price,
            compare_at_price: item?.variant?.compare_at_price,
            ...item
          });
        }
      }
      return acc;
    }, []);
  });
  const setModalStep = /* @__PURE__ */ __name((step) => {
    state.modal_step = step;
  }, "setModalStep");
  const updateBundleById = /* @__PURE__ */ __name((bundle_id = state.bundle_target_id) => {
    state.bundle_target_id = bundle_id;
    if (state.bundle_target_id || state.items_added?.length) {
      state.bundle_target = bundle_targets.find((target) => {
        if (bundle_type === "item_count") {
          return target.id === state.bundle_target_id && target.settings.target > state.items_added?.length;
        } else {
          return target.id === state.bundle_target_id;
        }
      })?.settings;
      if (!state.bundle_target && bundle_targets?.length) {
        const bundle_target = [...bundle_targets].sort((a, b) => a.settings.target - b.settings.target).find((target) => {
          if (bundle_type === "item_count") {
            return target.settings.target > state.items_added?.length;
          } else {
            return true;
          }
        }) ?? [...bundle_targets].sort((a, b) => b.settings.target - a.settings.target)?.[0];
        state.bundle_target = bundle_target?.settings;
        state.bundle_target_id = bundle_target?.id;
      }
    }
  }, "updateBundleById");
  const addToBundle = /* @__PURE__ */ __name(({
    product,
    variant,
    stepIndex,
    price,
    quantity,
    confirmed = false
  }) => {
    if (variant?.inventory_management && variant?.inventory_policy !== "continue") {
      const quantity_added = state.items_added.reduce((acc, item) => {
        if (item?.variant?.id === variant.id) {
          acc += 1;
        }
        return acc;
      }, 0);
      if (variant.inventory_quantity - quantity_added < 1) {
        _stores.toast.addToast({
          type: "error",
          title: "Not enough inventory",
          content: "It looks like you already added the item and the inventory limit has been reached."
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "hard_limit") {
      if (state?.[bundle_type] < state.bundle_target?.target) {
        if (confirmed) {
          state.items_added[stepIndex] = { product, variant, price_override: price };
        }
      }
    } else if (section_settings.restrict_bundle_quantity === "upgrade_limit") {
      const lastBundleTarget = [...bundle_targets].sort((a, b) => a?.settings?.target - b?.settings?.target)?.at(-1);
      if (state?.[bundle_type] < lastBundleTarget?.settings?.target) {
        if (confirmed) {
          state.items_added[stepIndex] = { product, variant, price_override: price };
        }
      } else {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!"
        });
        return;
      }
    } else if (section_settings.restrict_bundle_quantity === "no_limit") {
      if (confirmed) {
        state.items_added[stepIndex] = {
          product,
          variant,
          price_override: price,
          quantity,
          confirmed
        };
      }
    }
  
    // Always update step state (UI feedback)
    state.steps[stepIndex] = {
      skipped: false,
      confirmed: confirmed ?? false,
      open: !confirmed,
      variant_id: variant?.id,
      variant_title: variant?.title
    };
  
    if (confirmed) {
      openNextStep();
      updateBundleById();
    }
  
    console.log(state.items_added);
  }, "addToBundle");
  const updateStep = /* @__PURE__ */ __name(({
    index,
    open,
    skipped
  }) => {
    state.steps[index] = {
      ...state.steps[index],
      open: open ?? state.steps[index].open,
      skipped: skipped ?? state.steps[index].skipped
    };
  }, "updateStep");
  const openNextStep = /* @__PURE__ */ __name(() => {
    const nextStepIndex = state.steps.findIndex(
      (step) => step?.confirmed === false && step?.skipped === false
    );
    state.steps[nextStepIndex] = {
      ...state.steps[nextStepIndex],
      open: true
    };
  }, "openNextStep");
  const removeFromBundle = /* @__PURE__ */ __name(({
    product,
    variant
  }) => {
    const index = state.items_added?.findLastIndex(
      (item) => item?.variant?.id === variant?.id && item.product.id === product.id
    );
    state.items_added.splice(index, 1);
  }, "removeFromBundle");
  const removeFromBundleByIndex = /* @__PURE__ */ __name((stepIndex) => {
    if (state.items_added[stepIndex] && stepIndex > -1) {
      state.items_added.splice(stepIndex, 1);
      state.steps[stepIndex] = {
        skipped: false,
        open: false,
        confirmed: false
      };
    }
  }, "removeFromBundleByIndex");
  const handleAddToCart = /* @__PURE__ */ __name(async (action) => {
    state.isAdding = true;
    if (action === "add_to_cart") {
      _stores.modal.setId("cart-drawer");
      _stores.productDrawer.open = false;
      _stores.quickView.open = false;
      _stores.cart.loading = true;
    }
    const data = await _cart.add({
      items: state.items_added?.map((item) => {
        return {
          id: item?.variant?.id,
          properties: {
            _bundle_id: random_id,
            Bundle: state.achieved_bundle_target?.label
          },
          quantity: item?.quantity ?? 1
        };
      })
    });
    await _cart.update({
      attributes: {
        _source: state.achieved_bundle_target?.label || "bundle"
      }
    });
    if (data.cart_error) {
      state.isAdding = false;
      _stores.cart.loading = false;
      return;
    }
    if (action === "checkout") {
      document.querySelector(
        '[data-cart-drawer-checkout-form] button[name="checkout"]'
      )?.click();
      state.isAdding = false;
      state.items_added_to_cart = true;
      await utils.delay(3500);
      state.items_added_to_cart = false;
      return;
    }
    state.items_added = [];
    state.scroll_column_element = scroll_column_element;
    state.bundle_target_id = bundle_targets?.[0]?.id;
    state.total_price = 0;
    state.discounted_price = 0;
    state.final_price = 0;
    state.discount_wording = "";
    state.item_count = 0;
    state.target_difference = "";
    state.bundle_target = bundle_targets?.[0]?.settings;
    state.achieved_bundle_target = null;
    state.incentive_target = bundle_targets?.[0];
    state.isAdding = false;
    state.steps = [];
    _stores.cart.loading = false;
    await utils.delay(1e3);
    state.items_added_to_cart = false;
  }, "handleAddToCart");
  state.addToBundle = addToBundle;
  state.removeFromBundle = removeFromBundle;
  state.removeFromBundleByIndex = removeFromBundleByIndex;
  state.updateStep = updateStep;
  state.setModalStep = setModalStep;
  return {
    bundle: state,
    bundle_targets,
    bundle_target_objects,
    incentive_targets,
    section_settings,
    bundle_type,
    addToBundle,
    removeFromBundle,
    removeFromBundleByIndex,
    updateStep,
    setModalStep,
    handleAddToCart,
    openNextStep
  };
}, "initCustomBundle");
window._sections["initCustomBundle"] = initCustomBundle;
export {
  initCustomBundle
};
